export const apiUrls = {
  assureur: 'assureurs',
  assureurByProduit: 'get-devis-by-type-produit'
}
